import React,{ useState, useContext, useEffect } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Popover from '@mui/material/Popover';
import { AuthContext } from '../../contexts/authContext';
import CircleProgress  from '../../components/CircleProgress/CircleProgress';
import config          from '../../config';
import './index.css';
import useAppContext from '../../hooks/useAppContext';
import CircularProgress from '@mui/material/CircularProgress';
import {    
    AccountCircleSolidIcon,
    KeyIcon,
    LogoutIcon,
    ImpersonateIcon,
    HamburgerMenu
} from '../../assets/icons/icons';
import {
    Button
   ,Select
   ,FormControl
   ,MenuItem,
   IconButton
} from '@mui/material';
import MfaSettings from './userOptions/mfaSettings/MfaSettings';
import ChangePassword from './userOptions/changePassword/ChangePassword';
import Page403 from './errorPages/Page403';
import Page404 from './errorPages/Page404';
import Page500 from './errorPages/Page500';
import AsideMenu from '../../components/AsideMenu/AsideMenu';
import AdminManagement from './adminManagement/AdminManagement';
import Poi from './pois/Poi';
import Panels from './panels/Panels';
import Events from './events/Events';
import Logs from './logs/Logs';
import {ReactComponent as IGPLogo}  from '../../assets/svgs/IGPDecaux.svg';
import Groups from './groups/Groups';
import Tags from './tags/Tags';
import Tickers from './tickers/Tickers';
import Banners from './banners/Banners';
import Splashscreen from './splashscreen/Splashscreen';
import PanelsStatus from './panelsStatus/PanelsStatus';
import Fermate from './fermate/Fermate';
import Status from './status/Status';
import Update from './update/Update';
import useNotification from '../../hooks/useNotification';
import TickersEmergenza from './tickersEmergenza/TickersEmergenza';
import viariumLogo from 'assets/images/logoViarium.jpeg';

function MainIndex() {

    const {city, setCity, userEmail, setUserEmail} = useAppContext();
    const navigate = useNavigate();
    const { notificationError } = useNotification();
    const auth = useContext(AuthContext);
    const MFAtoConfig = localStorage.getItem('isMFAToConfig') === 'true';

    const [ loading, setLoading ] = useState(true);

    const [hardLoading, setHardLoading] = useState(true);

    const [ anchorUserSetting ,setAnchorUserSetting  ] = useState(null);

    const [ roleUser, setRoleUser ] = useState(false);
    const [ isUserInImpersonate, setIsUserInImpersonate ] = useState(false);

    const [ availableCities, setAvailableCities ] = useState([]);

    const [ menuStatusManager, setMenuStatusManager ] = useState(true);

    useEffect(() => {
        async function init () {
            try{
                let loggedEmail = '';
                let userAttributes = await auth.getAttributes();

                let emailUserObj = userAttributes.find(attribute => attribute.Name === 'email');
                let roleUserObj = userAttributes.find(attribute => attribute.Name === 'profile');
                let citiesUserObj = userAttributes.find(attribute => attribute.Name === 'zoneinfo');
                loggedEmail = emailUserObj?.Value;
                let role = roleUserObj?.Value;
                let cities = citiesUserObj?.Value.split(',');

                setCity(cities?.length ? cities[0] : '');
                setUserEmail?.(loggedEmail);
                setRoleUser(role);

                setAvailableCities(cities);

                setHardLoading(false);
            }catch{
                setHardLoading(false);
                logOut();
            }
            
        }
        init();
        setLoading(false);
    },[])

    const getProfile = async() => {
        try{
            let axiosParams = {
                url: 'profile',
                method: 'get',
                baseURL: config.API_URL,
                headers: {Authorization: `Bearer ${auth.sessionInfo?.accessToken}`},
            }

            /* let response = await axios(axiosParams);

            if(response.status === 200){
                setAdminUser(response.data.FLAG_ADMIN === 'Y' ? true : false);
                setUserEmail?.(response.data.EMAIL_ADDRESS);
                localStorage.setItem('admin', response.data.FLAG_ADMIN);
                localStorage.setItem('talent_manager', response.data.FLAG_TALENT_MANAGER);
                localStorage.setItem('referente_commerciale', response.data.FLAG_REF_COMM);
                localStorage.setItem('amministrazione', response.data.FLAG_AMMINISTRAZIONE);
            } */
        }catch (e){
            if(e.response.status===500){
                notificationError(typeof e.response.data.errorMessage === 'object' ? '' : e.response.data.errorMessage);
            }else if(e.response.status===401){
                notificationError('Non Autorizzato');
                logOut();
            }else{
                notificationError('Errore di Rete');
            }
        }
    }

    const goToHome = () => {
        navigate(config.HOME_PAGE);
    };

    const handleOpen = ( event, target ) =>{
        let targetCoords = (event.currentTarget);
        switch ( target ) {
            case 'user-settings':
                setAnchorUserSetting(targetCoords);
                break;

            default:
                console.log('hmm, mumble...');
                break;
        }
    };

    const handleClose = (target) => {
        switch ( target ) {
            case 'user-settings':
                setAnchorUserSetting(null);
                break;

            default:
                console.log('hmm, mumble...');
                break;
        }
    };

    const goToChangePassword = () => {
        handleClose();
        navigate('/change-password');
    }

    const goToImpersonate = () => {
        handleClose();
        navigate('/impersona');
    }

    const logOut = () =>{
        handleClose();
        auth.signOut();
        navigate('/login', {replace: false});
    }

    const endImpersonate = async() => {
        setIsUserInImpersonate(false);
        localStorage.removeItem('impersonateKUser');
        await getProfile();
        let loggedEmail = '';
        let userAttributes = await auth.getAttributes();
        let emailUserObj = userAttributes.find(attribute => attribute.Name === 'email');
        loggedEmail = emailUserObj?.Value;
        setUserEmail?.(loggedEmail);
    }

    if ( MFAtoConfig ) {
        // eslint-disable-next-line no-restricted-globals
        history.pushState({}, "", "/mfa-setup");
        return (
            <div className={"main-background"}>
                {
                    loading ? <CircleProgress /> : 
                    <>
                        <div className="main-content-mfa">
                            <div className="header-config-mfa">
                                <div className="header-container">
                                    <div>
                                        <span className="app-name cursor-defaul">Configurazione MFA</span>
                                        {/* <span className="app-name page-name cursor-defaul"> | {pageName} </span> */}
                                    </div>
                                    {/* dropdown-user-settings */}
                                    <Button className="mfa-configuration-exit-btn" onClick={logOut} startIcon={<LogoutIcon />}>Esci</Button>
                                </div>
                            </div>
                            <Routes>  
                                <Route path="/*"  element={<MfaSettings/>}/>
                            </Routes>
                        </div>
                    </>
                }
            </div>
        )
    } else if(hardLoading){
        return(
            <div className={"main-background"} style={{display:'flex', alignItems:'center', justifyContent:'center'}}>
                <CircularProgress />
            </div>
        )
    } else {
        return (
            <div className={"main-background"}>
                {
                    loading ? <CircleProgress /> : <>
                        <AsideMenu alwaysOpen={menuStatusManager} userIsAdmin={roleUser === 'A' ? true : false} role={roleUser}/>
                        <div className="main-content">
                            <div className="header">
                                <div className="header-container">
                                    <div className="header-container-menu-side">
                                        <a href='https://www.igpdecaux.it/it' target='_blank' rel="noreferrer" className="logo-container roobeekPath">
                                            <img src={viariumLogo} className="menu-logo-viarium" alt='viarium-logo'></img>
                                        </a>
                                        <IconButton onClick={() => {setMenuStatusManager(!menuStatusManager)}}><HamburgerMenu addClass="white-txt pointer"/></IconButton>
                                    </div>
                                    <div className="header-container-tools">
                                        {availableCities?.length > 1 && (
                                            <FormControl sx={{width: '120px'}} variant='standard'>
                                                <Select
                                                    id="select-city"
                                                    value={city}
                                                    onChange={(event) => setCity(event.target.value)}
                                                    sx={{
                                                        color: '#fff', // Colore del testo stampato
                                                        // 1. Colore della freccia a riposo
                                                        '& .MuiSelect-icon': {
                                                        color: '#fff',
                                                        transition: 'color 0.2s', // Opzionale: rende la transizione più fluida
                                                        },

                                                        // 2. Colore della freccia al passaggio del mouse (hover)
                                                        '&:hover .MuiSelect-icon': {
                                                        color: '#fff',
                                                        },

                                                        // 3. Colore della freccia quando la Select è aperta/focalizzata
                                                        '&.Mui-focused .MuiSelect-icon': {
                                                        color: '#fff',
                                                        },

                                                        // --- Gestione linee inferiori ---
                                                        '&:before': { borderColor: '#024676' },
                                                        '&:hover:not(.Mui-disabled):before': { borderColor: '#024676' },
                                                        '&:after': { borderColor: 'white' },
                                                    }}
                                                >
                                                    {availableCities.map(el => <MenuItem value={el.trim()}>{config.AVAILABLE_CITIES.find(item => item.id === el ).label}</MenuItem>)}
                                                </Select>
                                            </FormControl>
                                        )}
                                        
                                        <div>
                                            {isUserInImpersonate && (<ImpersonateIcon addClass='font-20'/>)}
                                        </div>
                                        {/* <div style={{position:'relative'}}>
                                            {isYellowBellToShow ?
                                                <IconButton onClick={handleOpenNotificationsDialog}>
                                                    <NotificationIconSolid addClass='yellow-bell-notification'/>
                                                </IconButton>
                                            :
                                                <IconButton onClick={handleOpenNotificationsDialog}>
                                                    <NotificationIcon addClass='font-20'/>
                                                </IconButton>
                                            }
                                        </div> */}
                                        <div className="user-settings-wrapper cursor-pointer" onClick={(event) => handleOpen(event, 'user-settings')}>
                                            <span>{userEmail}</span>
                                            <AccountCircleSolidIcon />
                                            <Popover
                                                open={Boolean(anchorUserSetting)}
                                                anchorEl={anchorUserSetting}
                                                onClose={() => handleClose('user-settings')}
                                                anchorOrigin={{
                                                    vertical: 'bottom',
                                                    horizontal: 'right',
                                                }}
                                                transformOrigin={{
                                                    vertical: 'top',
                                                    horizontal: 'right',
                                                }}
                                            >
                                                <ClickAwayListener onClickAway={() => handleClose('user-settings')}>
                                                    <div className="dropdown-user-settings">
                                                        <Button className="dropdown-user-options" onClick={goToChangePassword} startIcon={<KeyIcon/>}>Cambia Password</Button>
                                                        {/* {(adminUser || isUserInImpersonate)&&
                                                            <Button 
                                                                className="dropdown-user-options"
                                                                onClick={isUserInImpersonate ? endImpersonate : goToImpersonate}
                                                                startIcon={isUserInImpersonate ? <ImpersonateIconEnd/> : <ImpersonateIcon/>}>
                                                                    {isUserInImpersonate ? 'Fine Impersona' : 'Impersona'}
                                                            </Button>} */}
                                                        <Button className="dropdown-user-options" onClick={logOut} startIcon={<LogoutIcon />}>Esci</Button>
                                                    </div>
                                                </ClickAwayListener>
                                            </Popover>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <Routes>
                                
                                <Route path="/" element={<Panels {...{logOut, city}}/>}/>
                                <Route path="/panels" element={<Panels {...{logOut, city}}/>}/>
                                <Route path="/fermate" element={<Fermate {...{logOut, city}}/>}/>      
                                {(roleUser==='E' || roleUser==='A' || roleUser==='MU') &&(
                                    <>
                                        <Route path="/events" element={<Events {...{logOut, city}}/>}/>      
                                        <Route path="/pois" element={<Poi {...{logOut, city}}/>}/>
                                        <Route path="/groups" element={<Groups {...{logOut, city}}/>}/>
                                        <Route path="/tags" element={<Tags {...{logOut, city}}/>}/>
                                        <Route path="/tickers" element={<Tickers {...{logOut, city}}/>}/>
                                        <Route path="/tickers-emergency" element={<TickersEmergenza {...{logOut, city}}/>}/>
                                        <Route path="/banners" element={<Banners {...{logOut, city}}/>}/>
                                        <Route path="/splashscreen" element={<Splashscreen {...{logOut, city}}/>}/>
                                        {roleUser==='MU'&&(<Route path="/panels-status" element={<PanelsStatus {...{logOut, city, roleUser}}/>}/>)}
                                    </>
                                )}

                                {(roleUser==='M' || roleUser==='A') &&(
                                    <>
                                        <Route path="/logs" element={<Logs {...{logOut, city}}/>}/>
                                        <Route path="/status" element={<Status {...{logOut, city}}/>}/>
                                        <Route path="/panels-status" element={<PanelsStatus {...{logOut, city, roleUser}}/>}/>
                                    </>
                                )}
                                
                                {roleUser==='A'&&(
                                    <>
                                        <Route path="/management" element={<AdminManagement {...{logOut, city}}/>}/>
                                        <Route path="/update" element={<Update {...{logOut, city}}/>}/>
                                    </>
                                )}

                                <Route path="/change-password" element={<ChangePassword {...{logOut, city}}/>}/>

                                <Route path="/500"  element={<Page500/>}/>
                                <Route path="/403"  element={<Page403/>}/>
                                <Route path="/*"    element={<Page404/>}/>
                            </Routes>
                        </div>
                    </>
                }
            </div>
        )
    }
}

export default MainIndex;